<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">
            <!-- shape Hero -->
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('submenu.sector_news')}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section py-3">
            <div class="container">
                    <el-row :gutter="15">
                        <el-col :sm="12" :md="8" :lg="6" class="mb-3" v-for="item in news">
                            <div class="card card-lift--hover bg-defaultnew shadow border-0">
                                <router-link :to="`/t_news?id=${item.id}`">
                                    <img :src="`https://www.prokuratura.uz/api/download/${item.titleImage}`" class="card-img-top">
                                    <span class="sector_news_status">{{category.nameUz}}</span>
                                    <blockquote class="card-blockquote">
<!--                                        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"-->
<!--                                             viewBox="0 0 583 95"-->
<!--                                             class="svg-bg">-->
<!--                                            <polygon points="0,52 583,95 0,95" class="fill-defaultnew"></polygon>-->
<!--                                            <polygon points="0,42 583,95 683,0 0,95" opacity=".2"-->
<!--                                                     class="fill-default"></polygon>-->
<!--                                        </svg>-->
                                        <span class="badge badge-primary">{{parseDate(item.createdDate)}}</span>
                                        <h4 v-if="$i18n.locale === 'uz-UZ'" class="display-3 textnew-title_color title_text">{{item.titleUzLat}}</h4>
                                        <h4 v-if="$i18n.locale === 'uz-CYR'" class="display-3 textnew-title_color title_text">{{item.titleUz}}</h4>
                                        <h4 v-if="$i18n.locale === 'ru-RU'" class="display-3 textnew-title_color title_text">{{item.tilteRu}}</h4>
                                        <h4 v-if="$i18n.locale === 'en-US'" class="display-3 textnew-title_color title_text">{{item.titleEn}}</h4>
                                    </blockquote>
                                </router-link>
                            </div>
                        </el-col>
                    </el-row>
                <!--<div>-->
                    <!--<base-pagination :page-count="10" v-model="pagination.default"></base-pagination>-->
                <!--</div>-->
                <el-pagination
                        align="center"
                        background
                        layout="prev, pager, next"
                        :total="1000">
                </el-pagination>
            </div>
        </section>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        data() {
            return {
                pagination: {
                    default: 1
                },
                news: [],
                category: {},

                currentPage4: 1
            }
        },
        methods: {
            loadNewsByCategroy() {
                let categoryId = this.$route.query.category;
                this.$axios.get(`https://www.prokuratura.uz/api/categories/all`).then(response => {
                    response.data.forEach(category => {
                        if (category.id.toString() === categoryId) {
                            if (this.$i18n.locale === "en-US") {category.nameUz = category.nameEn;}
                            else if (this.$i18n.locale === "ru-RU") {category.nameUz = category.nameRu;}
                            else if (this.$i18n.locale === "uz-UZ") {category.nameUz = category.nameUzLat;}
                            this.category = category;
                        }
                    });
                });
                this.$axios.get(`https://www.prokuratura.uz/api/news/category/${categoryId}`).then(response => {
                    this.news = response.data;
                });
            },
            parseDate(dateTime) {
                return moment(dateTime).format("DD.MM.YYYY");
            }
        },
        mounted() {
            this.loadNewsByCategroy();
        },
        watch: {
            $route (to, from){
                this.loadNewsByCategroy();
            }
        }
    };
</script>
<style>
    .bg-defaultnew {
        background: #fff;
        cursor: pointer;
    }

    .fill-defaultnew {
        fill: #fff;
    }

    .sector_news_status {
        color: #fff;
        position: absolute;
        font-size: 12px;
        text-transform: uppercase;
        padding: 4px 8px;
        right: 10px;
        top: 10px;
        border-radius: 0px;
        background: #88a8af;
    }

    .text_center {
        text-align: center;
        text-transform: uppercase;
        margin-top: -65px;
        /*margin-bottom: 65px;*/
    }

</style>

<style scoped>
    /deep/ .card .card-blockquote {
        padding: 1rem;
        position: relative;
        padding-top: 5px;
        height: 88px;
    }
    /deep/ .badge {
        display: inline-block;
        padding: 0.35rem 0.375rem;
        font-size: 76%;
        font-weight: 600;
        margin-left: -6px;
        line-height: 1;
        text-align: center;
        position: absolute;
        white-space: nowrap;
        top: -32px;
        vertical-align: baseline;
        border-radius: 0rem;
    }
    /deep/ .badge-primary {
        color: #394869;
        background-color: #f0f4f9;
    }
    /deep/ .card .card-blockquote {
        padding: 1rem;
        position: relative;
        padding-top: 5px;
        height: 38px;
    }
    /deep/ .card-img-top {
        height: 240px;
        border-radius: 0px;
    }
    .textnew-title_color {
        color: #394869;
    }
</style>
